import EmployeeCompensation from './EmployeeCompensation';

export default EmployeeCompensation;
